import type { StateCreator } from 'zustand'

export type MetaSliceShape = {
	datasheetId: string
	setDatasheetId: (datasheetId: string) => void
}
export const createMetaSlice: StateCreator<MetaSliceShape> = (set) => ({
	datasheetId: '',
	setDatasheetId: (datasheetId) => set({ datasheetId }),
})
